// import vm from '../../main'
export default {
  className: 'updata',
  fields: [
    {
      // 安装包
      name: 'APK',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '安装包不可为空'
      ]
    },
    {
      // 说明
      name: 'message',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '更新说明不可为空'
      ]
    },
    {
      // 版本号
      name: 'version',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '版本号不可为空'
      ]
    },
    {
      // 黑名单
      name: 'blacklist',
      tooltip: '序列号之间用空格分隔'
    },
    {
      // 白名单
      name: 'whiteList',
      tooltip: '序列号之间用空格分隔'
    }
  ],
  action: {
    export: false
  },
  search: [
    'version'
  ],
  hooks: {
    beforeSave ({ data }) {
      if (data.blacklist != null && data.whiteList != null) {
        if (data.blacklist !== '' && data.whiteList !== '') {
          throw new Error('黑名单与白名单无法同时存在')
        }
      }
    }
  }
}
